import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=69706e6a&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=69706e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69706e6a",
  null
  
)

export default component.exports